<template>

<p v-html="text"/>

</template>

<script>
export default {
  name: 'Common',
  props: {
    text: String
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 24px;
  text-align: left;
  line-height: 1.54;
}
</style>
